import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getLocalStorageLoginToken } from "src/utils/localStorageWorker";
import { getIsLoggedOut, getUser } from "../../../../store/login/selectors";

const useEnsureUserIsLoggedIn = () => {
  const user = useSelector(getUser);
  const { pathname, search } = useLocation();
  const history = useHistory();

  useEffect(() => {
    const loginToken = getLocalStorageLoginToken();
    if (user === null || user === undefined) {
      if (!loginToken && pathname !== "/login") {
        history.push({
          pathname: "/login",
        });
        return;
      }

      const fullEncodedURI = encodeURIComponent(`${pathname}${search}`);
      if (pathname !== `/login`) {
        history.push({
          pathname: `/login`,
          search: `?redirectUrl=${fullEncodedURI}`,
        });
      }
    }
  }, [user, pathname, search, history]);
};

export default useEnsureUserIsLoggedIn;
